export enum ENUM__workspace_entity_viewer {
  APP_USER = 'APP_USER',
  GUEST = 'GUEST',
  WORKSPACE_USER = 'WORKSPACE_USER',
}
